import { useListUnlockedPrivateSongs } from "@hooks/trpc/useListUnlockedPrivateSongs";

export const useIsPrivateSongUnlocked = (songId?: string): boolean => {
  const unlockedSongIds = useListUnlockedPrivateSongs();

  if (!songId) {
    return false;
  }

  if (!unlockedSongIds) {
    return false;
  }

  return unlockedSongIds.includes(songId);
};
